module.exports = __webpack_public_path__ + "img/summer_landscape_flatline.c9adecd2.svg";